import React from "react";
import { Card, Table, TableBody, TableCell, TableRow } from "@mui/material";
import {
  CustomTableContainer,
  CustomTableHead,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import { useSelector } from "react-redux";
import { AdminTitleHolder } from "../../../common/sharedComponents/styles/card.style";
import moment from "moment";

function ProjectViewItems() {
  const { projectItems } = useSelector((state) => state.project);

  return (
    <div>
      <AdminTitleHolder sx={{ mt: 2 }}>
        <b>Project Items</b>
      </AdminTitleHolder>
      <CustomTableContainer component={Card}>
        <Table>
          <CustomTableHead>
            <TableRow>
              <TableCell style={{ minWidth: "120px" }}>
                <TableHeaderFont>Item Code</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "200px" }}>
                <TableHeaderFont>Item Name</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "250px" }}>
                <TableHeaderFont>Description</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "80px" }}>
                <TableHeaderFont>Req Qty</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "80px" }}>
                <TableHeaderFont>UOM</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "120px" }}>
                <TableHeaderFont>Start Date</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "120px" }}>
                <TableHeaderFont>End Date</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "150px" }}>
                <TableHeaderFont>Sourcing Strategy</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "150px" }}>
                <TableHeaderFont>Target Contracts</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "200px" }}>
                <TableHeaderFont>Justification</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "150px" }}>
                <TableHeaderFont>Supplier</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "150px" }}>
                <TableHeaderFont>Budget Owner Name</TableHeaderFont>
              </TableCell>
              <TableCell style={{ minWidth: "120px" }}>
                <TableHeaderFont>Budget</TableHeaderFont>
              </TableCell>
            </TableRow>
          </CustomTableHead>
          <TableBody>
            {projectItems?.length > 0 ? (
              projectItems.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item?.material?.MaterialCode || "-"}</TableCell>
                  <TableCell>{item?.material?.Description || "-"}</TableCell>
                  <TableCell>{item?.description || "-"}</TableCell>
                  <TableCell>{item?.quantity || "-"}</TableCell>
                  <TableCell>{item?.uom || "-"}</TableCell>
                  <TableCell>
                    {item?.expected_start_date
                      ? moment(item.expected_start_date).format("DD-MM-YYYY")
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {item?.expected_completion_date
                      ? moment(item.expected_completion_date).format(
                          "DD-MM-YYYY",
                        )
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {item?.recommended_sourcing_strategy || "-"}
                  </TableCell>
                  <TableCell>{item?.target_contracts || "-"}</TableCell>
                  <TableCell>{item?.justification || "-"}</TableCell>
                  <TableCell>{item?.suggested_supplier || "-"}</TableCell>
                  <TableCell>{item?.budget_owner_id || "-"}</TableCell>
                  <TableCell>{item?.budget || "-"}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={13} align="center">
                  No items found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CustomTableContainer>
    </div>
  );
}

export default ProjectViewItems;
